import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=fc6680be&scoped=true"
import script from "./searchDetail.vue?vue&type=script&lang=js"
export * from "./searchDetail.vue?vue&type=script&lang=js"
import style0 from "./searchDetail.vue?vue&type=style&index=0&id=fc6680be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6680be",
  null
  
)

export default component.exports